import { getLang } from './i18n';

// Paginile legale traiesc pe `newmind.ro`, nu in aplicatie: un singur text, care nu se poate
// contrazice cu el insusi. Fiecare are romana sus si engleza dedesubt, sub ancora `english`
// (19 septembrie 2026).
//
// Cand ecranul e pe engleza, linkul duce DIRECT la partea engleza. Altfel recenzorul Meta, care
// citeste in engleza, ar ateriza intr-un text romanesc si ar trebui sa deruleze pana gaseste ce
// ii trebuie — exact genul de lucru care se soldeaza cu o respingere.
export const LEGAL = {
  confidentialitate: 'https://newmind.ro/politica-de-confidentialitate-nm-social/',
  termeni: 'https://newmind.ro/termeni-si-conditii-nm-social/',
  stergere: 'https://newmind.ro/stergerea-datelor-nm-social/',
  cookies: 'https://newmind.ro/politica-de-cookies-nm-social/',
};

export function legal(care) {
  const adresa = LEGAL[care];
  if (!adresa) return 'https://newmind.ro/';
  return getLang() === 'en' ? adresa + '#english' : adresa;
}
